import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import { Helmet } from 'react-helmet';

import {
	extractAudiences,
	linkWithQueryParams,
	queryParamsFromFilters
} from 'inside-out/managers/resourceLibraryManager';
import { idToLink } from 'inside-out/managers/navManager';

import { PageHeader } from 'inside-out/components/shared/pageHeader';
import { PageNav } from 'inside-out/components/shared/pageNav';
import { Cards } from 'inside-out/components/shared/cards';
import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard';
import { ResearchStaticCard } from 'inside-out/components/shared/cards/researchStaticCard';

import ResearchBG from 'inside-out/images/research/bg.svg';

import {
	purple,
	burnedOrange,
	tabletLandscapeMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
} from 'inside-out/global-styles';

import {
	innerWrapperStyle,
	titleStyle,
	subTitleStyle,
	textStyle,
	contentSectionStyle,
	cardSectionStyle,
	currentResearchWrapperStyle,
} from 'inside-out/page-styles/project';

const ResourcePropType = PropTypes.shape({
	id: PropTypes.string,
	title: PropTypes.string,
	type: PropTypes.string,
	date: PropTypes.string,
	fields: PropTypes.shape({
		thumbnail_image: PropTypes.shape({
			childImageSharp: PropTypes.shape({
				resize: PropTypes.shape({
					src: PropTypes.string.isRequired,
				}).isRequired,
			}).isRequired,
		}).isRequired,
	}).isRequired,
	attachments: PropTypes.arrayOf(
		PropTypes.shape({
			vimeo_url: PropTypes.string,
		})
	),
});

export default class ProjectPage extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							purple_heading: PropTypes.string.isRequired,
							purple_body: PropTypes.string.isRequired,
							heading: PropTypes.string.isRequired,
							body: PropTypes.string.isRequired,
							current_project_heading: PropTypes.string.isRequired,
							current_project: PropTypes.arrayOf(
								PropTypes.shape({
									heading: PropTypes.string.isRequired,
									body: PropTypes.string.isRequired,
								})
							),
							project_noticeboard_heading: PropTypes.string.isRequired,
							project_tile_heading: PropTypes.string.isRequired,
							project_tile_body: PropTypes.string.isRequired,
							project_positions_heading: PropTypes.string.isRequired,
							project_positions_tile_heading: PropTypes.string.isRequired,
							project_positions_tile_body: PropTypes.string.isRequired,

							resource_1: ResourcePropType,
							resource_2: ResourcePropType,
							resource_3: ResourcePropType,
							resource_4: ResourcePropType,
						}),
					})
				),
			}),
		}),
	};

	render() {
		const pageSettings = this.props.data.page.edges[0].node;

		const resources = [
			pageSettings.resource_1,
			pageSettings.resource_2,
			pageSettings.resource_3,
			pageSettings.resource_4,
		];

		return (
			<React.Fragment>
				<Helmet title={pageSettings.purple_heading}>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={pageSettings.purple_heading}/>
          <meta name="description" content={pageSettings.purple_body}/>
          <meta property="og:description" content={pageSettings.purple_body}/>
        </Helmet>

				<PageHeader
					background={`${purple} url(${ResearchBG}) no-repeat bottom right`}
					titleText={pageSettings.purple_heading}
					titleTextColor="#fff"
					subTitleText={pageSettings.purple_body}
					subTitleTextColor="#fff"
				/>

				<section className={contentSectionStyle('#fff')}>
					<div className={innerWrapperStyle}>
						<header>
							<h1 className={titleStyle}>{pageSettings.heading}</h1>
						</header>
						<div className={textStyle} dangerouslySetInnerHTML={{ __html: pageSettings.body }} />
					</div>
				</section>

				{pageSettings.current_project &&
					pageSettings.current_project.length && (
						<section>
							<div className={innerWrapperStyle}>
								<div className={currentResearchWrapperStyle}>
									<header>
										<h1 className={subTitleStyle}>{pageSettings.current_project_heading}</h1>
									</header>
									<Cards
										columns={3}
										scrollable={false}
										columnsAt={{
											[`max-width: ${tabletLandscapeMaxWidthBreakpoint}`]: 2,
											[`max-width: ${tabletPortraitMaxWidthBreakpoint}`]: 1,
										}}
									>
										{pageSettings.current_project.map((currentResearch, i) => (
											<ResearchStaticCard
												key={i}
												title={currentResearch.heading}
												collaborations={currentResearch.collaborations}
												body={currentResearch.body}
											/>
										))}
									</Cards>
								</div>
							</div>
						</section>
					)}
			</React.Fragment>
		);
	}
}

export const query = graphql`
	query ProjectPageQuery {
		page: allContentJson(filter: { id: { regex: "/content\\/project-page\\.json/" } }) {
			edges {
				node {
					purple_heading
					purple_body
					heading
					body
					current_project_heading
					current_project {
						heading
						collaborations
						body
					}

					resource_1 {
						...resource
					}
					resource_2 {
						...resource
					}
					resource_3 {
						...resource
					}
					resource_4 {
						...resource
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/projects/index.js